import React from "react";
import { Link } from "react-router-dom";

import { HOME_TEAM, ROUTES } from "../../data/content";
import { teamMemberId } from "../team/Team";

const ArrowIcon = ({ direction }) => (
  <svg
    viewBox={"0 0 23 39"}
    aria-hidden={"true"}
  >
    <path d={direction === "left" ? "M20 2L3 19.5 20 37" : "M3 2l17 17.5L3 37"} />
  </svg>
);

//Row of team photos running edge to edge, as on the original: fixed-size squares from the left of the window, so wider
//screens show more of them (about four on a 1920px screen). Swipe / scroll sideways, or use the arrows
const TeamCarousel = () => {
  const trackRef = React.useRef(null);
  const [canScroll, setCanScroll] = React.useState({ left: false, right: true });

  const updateArrows = () => {
    const track = trackRef.current;
    if (!track) {
      return;
    }
    setCanScroll({
      left: track.scrollLeft > 4,
      right: track.scrollLeft + track.clientWidth < track.scrollWidth - 4,
    });
  };

  React.useEffect(() => {
    updateArrows();
    window.addEventListener("resize", updateArrows);
    return () => window.removeEventListener("resize", updateArrows);
  }, []);

  //Move along by one photo
  const scroll = (direction) => {
    const track = trackRef.current;
    const item = track.querySelector(".team-carousel-item");
    const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
    track.scrollBy({ left: direction * step, behavior: "smooth" });
  };

  return (
    <div className={"team-carousel"}>
      <ul
        ref={trackRef}
        className={"team-carousel-track"}
        onScroll={updateArrows}
      >
        {HOME_TEAM.map((member) => (
          <li
            key={member.name}
            className={"team-carousel-item"}
          >
            <Link
              to={`${ROUTES.TEAM}#${teamMemberId(member)}`}
              className={"team-carousel-card"}
            >
              {/* Square crops with headroom added above everyone's head (images/team/square). Not lazy-loaded: browsers
                  (esp. iOS Safari) often never load lazy images that start off-screen in a sideways-scrolling row */}
              <img
                src={member.photo.replace("/team/", "/team/square/")}
                alt={member.name}
                width={433}
                height={433}
                decoding={"async"}
              />
              <span className={"team-carousel-name"}>{member.name}</span>
              <span className={"team-carousel-role"}>{member.homeRole || member.role}</span>
            </Link>
          </li>
        ))}
      </ul>
      <button
        type={"button"}
        className={"team-carousel-arrow is-left"}
        onClick={() => scroll(-1)}
        disabled={!canScroll.left}
        aria-label={"Previous team member"}
      >
        <ArrowIcon direction={"left"} />
      </button>
      <button
        type={"button"}
        className={"team-carousel-arrow is-right"}
        onClick={() => scroll(1)}
        disabled={!canScroll.right}
        aria-label={"Next team member"}
      >
        <ArrowIcon direction={"right"} />
      </button>
    </div>
  );
};

export default TeamCarousel;
